import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PrivateRoute from "components/PrivateRoute";
import { AuthProvider } from "./contexts/AuthContext";
import PageTransition from "./components/PageTransition";
import SystemConfiguration from './pages/system-configuration';
import UserManagement from './pages/user-management';
import AdministrativeDashboard from './pages/administrative-dashboard';
import UserRegistration from './pages/user-registration';
import UpdateManagement from './pages/update-management';
import CustomerUserDashboard from './pages/customer-user-dashboard';
import AnalyticsDashboard from './pages/analytics-dashboard';
import LoginPage from './pages/login';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <PageTransition>
            <RouterRoutes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/user-registration" element={<UserRegistration />} />
              <Route path="/unauthorized" element={<NotFound />} />

              {/* Root redirect */}
              <Route path="/" element={<Navigate to="/login" replace />} />

              {/* SUPER_ADMIN + ADMIN routes */}
              <Route path="/administrative-dashboard" element={
                <PrivateRoute allowedRoles={['SUPER_ADMIN', 'ADMIN']}>
                  <AdministrativeDashboard />
                </PrivateRoute>
              } />
              <Route path="/user-management" element={
                <PrivateRoute allowedRoles={['SUPER_ADMIN', 'ADMIN']}>
                  <UserManagement />
                </PrivateRoute>
              } />
              <Route path="/analytics-dashboard" element={
                <PrivateRoute allowedRoles={['SUPER_ADMIN', 'ADMIN']}>
                  <AnalyticsDashboard />
                </PrivateRoute>
              } />

              {/* SUPER_ADMIN only */}
              <Route path="/system-configuration" element={
                <PrivateRoute allowedRoles={['SUPER_ADMIN']}>
                  <SystemConfiguration />
                </PrivateRoute>
              } />

              {/* SUPER_ADMIN + ADMIN + OPERATOR */}
              <Route path="/update-management" element={
                <PrivateRoute allowedRoles={['SUPER_ADMIN', 'ADMIN', 'OPERATOR']}>
                  <UpdateManagement />
                </PrivateRoute>
              } />

              {/* CUSTOMER_USER */}
              <Route path="/customer-user-dashboard" element={
                <PrivateRoute allowedRoles={['CUSTOMER_USER']}>
                  <CustomerUserDashboard />
                </PrivateRoute>
              } />

              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </PageTransition>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
